import {
    GETMERCHANTCHARGELIST_SUCCESS,
    GETMERCHANTCHARGELIST_FAILED,
    RESET_GETMERCHANTCHARGELIST,
    LOADING_GETMERCHANTCHARGELIST,
    NETWORK_ERROR_GETMERCHANTCHARGELIST
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetMerchantChargeList = () => {
    return { type: RESET_GETMERCHANTCHARGELIST };
};

const getMerchantChargeList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMERCHANTCHARGELIST });
    await partnerServices
        .post("listOfMerchantCharges", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getMerchantChargeListsuccess(res.data));
                    break;
                default:
                    dispatch(getMerchantChargeListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMERCHANTCHARGELIST,
                payload: err
            });
        });
};
function getMerchantChargeListsuccess(data) {
    return {
        type: GETMERCHANTCHARGELIST_SUCCESS,
        payload: data
    };
}
function getMerchantChargeListFailed(data) {
    return {
        type: GETMERCHANTCHARGELIST_FAILED,
        payload: data
    };
}

export { resetGetMerchantChargeList, getMerchantChargeList };
